import Vue from "vue";
import VueRouter from "vue-router";
//import air from '../views/encoder/air/air'
import airsensor from '../views/encoder/air/sensor'
import soil from '../views/encoder/soil/soil'
import soilsensor from '../views/encoder/soil/sensor'
import sense from '../views/encoder/sense/sense'
// import sensesensor from '@/view/encoder/sense/sensor'
// import pest from '@/view/encoder/pest/pest'
// import pestsensor from '@/view/encoder/pest/sensor'
// import sexual from '@/view/encoder/sexual/sexual'
// import sexualsensor from '@/view/encoder/sexual/sensor'
import camera from '../views/encoder/camera/camera'
import newMap1 from '../views/newMap1'
import log from '../views/log'
import account from '../views/center/account'
import password from '../views/center/password'

Vue.use(VueRouter);

const routes = [

  {
    path: "/",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login.vue"),
    meta: {
      sider: 'login',
      keepAlive: false, //此页面需要缓存
    },
  },
  {
    path: "/equip",
    name: "HomeView",
    meta: {
      keepAlive: true, //此页面需要缓存
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeView.vue"),
  },
  {
    path: '/log/',
    name: 'log',
    component: log,
    meta: {
      auth: true,
      sider: 'home',
      appClass: '',
      title: '运行日志'
    }
  }, {
    path: '/account/',
    name: 'account',
    component: account,
    meta: {
      auth: true,
      sider: 'home',
      appClass: '',
      title: '账户信息'
    }
  }, {
    path: '/password/',
    name: 'password',
    component: password,
    meta: {
      auth: true,
      sider: 'home',
      appClass: '',
      title: '修改登录密码'
    }
  },
  {
    path: "/home",
    name: "home",
    meta: {
      //  keepAlive: true, //此页面需要缓存
    },
    meta: {
      auth: true,
      sider: 'home',
      appClass: '',
      title: '设备首页'
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/home/home"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    meta: {
      keepAlive: false //此页面需要缓存
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/detail.vue"),
  },
  {
    path: "/echarts",
    name: "echarts",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/echarts.vue"),
  },
  {
    path: "/video",
    name: "video",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/video.vue"),
  },

  {
    path: '/encoder/air/:id',
    name: 'air',
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/encoder/air/air"),
    meta: {
      auth: true,
      sider: 'encoder',
      appClass: '',
      title: '设备信息',
      type: 'air'
    }
  },

  /**
   * 土壤数据
   */
  {
    path: '/encoder/soil/:id',
    name: 'soil',
    component: soil,
    meta: {
      auth: true,
      sider: 'encoder',
      appClass: '',
      title: '设备信息',
      type: "soil"
    }
  },
  /**
          * 视频监控系统
          */
  {
    path: '/encoder/camera/:id',
    name: 'camera',
    component: camera,
    meta: {
      auth: true,
      sider: 'encoder',
      appClass: '',
      title: '设备信息',
      type: "camera"
    }
  },
  /**
  * 遥感数据
  */
  {
    path: '/encoder/sense/:id',
    name: 'sense',
    component: sense,
    meta: {
      auth: true,
      sider: 'encoder',
      appClass: '',
      title: '设备信息',
      type: 'sense'
    }
  },

  {
    path: '/encoder/soil/sensor/:group/:id/:sid?',
    name: 'soilsensor',
    component: soilsensor,
    meta: {
      auth: true,
      sider: 'sensor',
      appClass: '',
      title: '设备信息'
    }
  }, {
    path: '/encoder/air/sensor/:id/:sid',
    name: 'airsensor',
    component: airsensor,
    meta: {
      auth: true,
      sider: 'sensor',
      appClass: '',
      title: '设备信息'
    }
  }
];

const router = new VueRouter({
  // mode: 'hash',
  linkActiveClass: 'active',
  routes,
});

export default router;
